import { render, staticRenderFns } from "./CuponeraFormComponent.vue?vue&type=template&id=2011afac&"
import script from "./CuponeraFormComponent.vue?vue&type=script&lang=js&"
export * from "./CuponeraFormComponent.vue?vue&type=script&lang=js&"
import style0 from "./CuponeraFormComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports